import styled from "@emotion/styled";
import * as React from "react";

import { Avatar, SpacingToken, Text } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  displayName: string;
  email: string | null;
}

export const EmailPreview: React.FC<IProps> = ({ displayName, email }) => (
  <Flex padding={withVar(SpacingToken.Spacing5)} overflow="auto" gap={withVar(SpacingToken.Spacing4)}>
    <StyledAvatar type="text" text={displayName} size="medium" />
    <Flex column gap={withVar(SpacingToken.Spacing6)}>
      <div>
        <Text bold>{displayName}</Text>
        {email && (
          <>
            <Text>&lt;{email}&gt;</Text>
          </>
        )}
        <Text>to Lisa Goodman</Text>
      </div>
      <Text>
        Hi Lisa,
        <br />
        Thank you for your message.
        <br />
        Your dream shoes are in stock. 🎉
      </Text>
    </Flex>
  </Flex>
);

const StyledAvatar = styled(Avatar)`
  margin-top: ${withVar(SpacingToken.Spacing3)};
`;
